import * as constantsAPI from "@constants"
const { ReduxConstants: { REDUX_CONSTANTS = {} } = {} } = constantsAPI || {}

export const updateCountry = (country) => (dispatch) => {
  dispatch({
    type: REDUX_CONSTANTS.UPDATE_COUNTRY,
    country: country,
  })
}
